module.exports = veCoreMfeConfig;